export default __webpack_public_path__ + "static/media/ConsumerLoginImage.b0129cb6.png";